import { render, staticRenderFns } from "./DownloadButtonWithIcon.vue?vue&type=template&id=40bcf6a7&scoped=true&"
import script from "./DownloadButtonWithIcon.vue?vue&type=script&lang=js&"
export * from "./DownloadButtonWithIcon.vue?vue&type=script&lang=js&"
import style0 from "./DownloadButtonWithIcon.vue?vue&type=style&index=0&id=40bcf6a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bcf6a7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
